import React from 'react';
import { DailyDelivery } from '../driverPerformanceTypes';
import styles from './WeeklyBarChart.module.css';

interface WeeklyBarChartProps {
  data: DailyDelivery[];
}

export const WeeklyBarChart: React.FC<WeeklyBarChartProps> = ({ data }) => {
  const max = Math.max(...data.map((d) => d.count), 1);

  return (
    <div className={styles.card}>
      <h3 className={styles.title}>Deliveries This Week</h3>
      <div className={styles.chart}>
        {data.map((d) => {
          const heightPct = (d.count / max) * 100;
          return (
            <div key={d.day} className={styles.col}>
              <div className={styles.barWrap}>
                <div
                  className={styles.bar}
                  style={{ height: `${Math.max(heightPct, 8)}%` }}
                  title={`${d.count} deliveries`}
                />
              </div>
              <span className={styles.day}>{d.day}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
